// shizzleView.js

// simple interface to search for, and view a single asset/domain

import React from 'react';

import { Button, Divider, Icon, Input } from 'semantic-ui-react'

import Identicon from 'react-identicons'

import Toast    from './toast';

import {
  openDB,
  //findLatestContinue,
  //findLatestContinue2,
  //getClosestToLimb,
  queryFunction,
  queryFetchDecodeTx,
  findNextTx,
  getTheNextAddress,
  //getNextDialogAddress,
  getNextDialog,

  registerASubscription,
  unRegisterASubscription,
  registerDomainOfMine,
  unRegisterDomainOfMine,
  findADomainOfMine,
  findAllDomainsOfMine,
  //findADialog,
  //findAllTheDialogs,
  getASubscription,
  //mySleep

  hexByteToAscii,
  hexStringToAscii,

  maybeDecryptContent,

  APP_TITLE,

  findTipOfDomain,
  tryGoingFurtherInTransients,
  tryGoingFurtherInUpdates

} from '../node_modules/shizzle-core/dist/es/shizzle-core.js'

import ProgressListModal from './progressListModal.js'
import ContentPresenter from './contentPresenter.js';

import DialogModal from './dialogModal.js';
import DomainModal from './domainModal.js';
import SubscriptionsModal from './subscriptionsModal.js';


import './index.css';


/**
 * When instantiating, include these props:
 *     parent
 *     show
 *     handleSwitchToShizzleNav
 *     registerCient
 */
class ShizzleView extends React.PureComponent {
  constructor(props) {
    super(props);
    document.title = APP_TITLE

    this.handleViewerClick     = this.handleViewerClick.bind(this);
    this.handleDomainBarChange = this.handleDomainBarChange.bind(this);
    this.goToClickedDomain     = this.goToClickedDomain.bind(this);
    this.goToClickedDialog     = this.goToClickedDialog.bind(this);
    this.goToDomain            = this.goToDomain.bind(this);
    this.closeProgressList     = this.closeProgressList.bind(this);
    this.workCanceled          = this.workCanceled.bind(this);
    this.doWork                = this.doWork.bind(this);

    this.visitTheGuestFunc     = this.visitTheGuestFunc.bind(this);

    this.handlePrevious        = this.handlePrevious.bind(this);
    this.handleForward         = this.handleForward.bind(this);
    this.setAddressBar         = this.setAddressBar.bind(this);
    this.nullProgressFunc      = this.nullProgressFunc.bind(this);

    this.openDialogMenu        = this.openDialogMenu.bind(this);
    this.openDomainMenu        = this.openDomainMenu.bind(this);
    this.openSubscriptionsMenu = this.openSubscriptionsMenu.bind(this);
    this.registerADomainOfMine = this.registerADomainOfMine.bind(this);
    this.unRegisterADomainOfMine = this.unRegisterADomainOfMine.bind(this);
    this.subscribeToDomain     = this.subscribeToDomain.bind(this);
    this.unSubscribeToDomain   = this.unSubscribeToDomain.bind(this);
    this.getRelevantOutputIndex= this.getRelevantOutputIndex.bind(this);
    this.getOwnerCountAndLimb  = this.getOwnerCountAndLimb.bind(this);

    this.processSearchResults  = this.processSearchResults.bind(this);

    this.submodeSetDomainFunction = this.submodeSetDomainFunction.bind(this);
    this.submodeClickButton       = this.submodeClickButton.bind(this);
    this.plmReset = null

    this.setReportOnGuestPosts    = this.setReportOnGuestPosts.bind(this);
    this.reportGuestPostFunc   = this.reportGuestPostFunc.bind(this);

    this.jumpToTx              = this.jumpToTx.bind(this);
    this.reCalcOurDomains      = this.reCalcOurDomains.bind(this);

    this.handlePostTweetClick  = this.handlePostTweetClick.bind(this);

    this.shareLinkToPost       = this.shareLinkToPost.bind(this);
    this.quickToast            = this.quickToast.bind(this);
    this.quickToastDone        = this.quickToastDone.bind(this);

    const windowURL = window.location.href // returns the absolute URL of a page
    console.warn("SView: our URL (may be useful for innerFrame logic): ", windowURL)

    const windowPathname = window.location.pathname
    const pathSplit = windowPathname.split('/')
    console.log("SView: window pathname split : ", pathSplit)
    const viewMode = pathSplit.length > 0 ? pathSplit[1] : 'nav'    // nav or view
    console.warn("SView:   initial viewMode: " + viewMode)

    if ( pathSplit.length > 2 && pathSplit[2].length > 0 ) {

      //NOTE: we're currently passive wrt the address bar
      //      ShizzleNav reacts to the address bar

      console.warn("SView: MAYBE we're being asked to look at shizzle asset URL bshz://" + windowPathname)

      //if ( viewMode === 'nav' ) {
      //  console.warn("Will change to 'nav' view...")
      //  this.props.handleSwitchToShizzleNav()
      //}
    }

    this.state = {
      currentTxId: null,
      decodedTx: '',
      found: false,
      owned: false,
      reachedLimb: '',
      extraVerbage: '',

      domainToVisit: '',
      foundOwnerCount: 0,     // set only when reporting submodeResponse
      openTheProgressList: false,
      jobCanceled: false,
      count: 0,            // for progressModalList   - for unique lines?  //FIXME: rename to more descriptive

      dialogMenuOpen:        false,
      domainMenuOpen:        false,
      subscriptionsMenuOpen: false,

      registeredToUs: false,
      weSubscribeToThis: false,

      txClass: 'regular',

      showQuickToast:         false,
      toastText:              '',
      toastDuration:          800,
      suppressLoader:         false,
    };


    // We found this necessary for WoC
    //this.initialSleepForProviders = 300
    //this.iterativeSleepForProviders = 250
    //REDUCED on 10/31/22 since we now have simple provider management (alternating providers)
    //this.initialSleepForProviders = 100
    //this.iterativeSleepForProviders = 50
    //REDUCE again on same day
    //this.initialSleepForProviders = 75
    //this.iterativeSleepForProviders = 25
    //REDUCE again on same day
    this.initialSleepForProviders = 50
    this.iterativeSleepForProviders = 40     // 6/30/23  20ms was too quick. Increased to 40ms
  }

  componentWillUnmount() {
    console.warn("ShizzleView about to unmount. Will UNregister...")

    if ( this.props.parent && this.props.unregisterClient ) {
console.log("shizzleView cWU() start")
      this.props.unregisterClient(this.props.parent, this, "shizzleView")
console.log("shizzleView cWU() end")
    }

    // fix Warning: Can't perform a React state update on an unmounted component
    // see: https://stackoverflow.com/questions/53949393/cant-perform-a-react-state-update-on-an-unmounted-component
    this.setState = (state,callback)=>{
        return;
    };
  }

  async reCalcOurDomains() {

    const domainsArray = await findAllDomainsOfMine(await openDB())

    console.log("reCalcOurDomains(): ", domainsArray)

    // Maybe this can help us when we look to display our dialogs
//FIXME: but, we'd want to update it when adding/removing domains
    this.setState({ourDomainsArray: domainsArray})
  }

  async componentDidMount() {

    console.warn("SV componentDidMount()")

    if ( this.props.parent && this.props.registerClient ){
      this.props.registerClient(this.props.parent, this, "shizzleView")
    }

    if ( this.props.submode ) {
      console.error("SHIZZLE VIEW is in a special mode - SUB mode")

      if ( this.props.registerSubmodeCallback && this.props.parent ) {

        // Give parent access to some functions of ours
        // NOTE: we now register THREE callback functions
        this.props.registerSubmodeCallback( this.props.parent,
                                            this,
                                            this.submodeSetDomainFunction, // kicks-off walking to the tip of a domain
                                            this.submodeClickButton,       // back/fwd   FIXME: rename to submodeNavigationClick ?
                                            this.setReportOnGuestPosts)    // whether to report on announced domains (guest-posts on 'banno')
      }

      // we want to INSTANTLY start searching through a specified domain
      this.setState({domainToVisit: this.props.domainToView, openTheProgressList: true})
    }

    await this.reCalcOurDomains()
  }

  // Here, the parent can direct us to go to a domain
  submodeSetDomainFunction(self, domain) {
    console.warn("shizzleView submodeSetDomainFunction() We've been told to jump to domain: " + domain)

    this.plmReset()

    self.goToClickedDomain(self, domain)
  }

  setReportOnGuestPosts(self, value) {
    console.error("shizzleView(): changing setting of reportOnGuestPosts: " + value)
    self.setState({reportOnGuestPosts: value})
  }

  // The parent can 'control' our display (forward, or back a tx), by calling this
  async submodeClickButton(self, buttonType, extraParam = null) {
    console.warn("shizzleView submodeClickButton(). we've been passed buttonType: " + buttonType)
    if ( buttonType === 'next' ) {
      console.warn("jumping FORWARD one tx")
      await this.handleForward(false)
    } else if ( buttonType === 'prev' ) {
      console.warn("jumping BACKWARD one tx")
      await this.handleForward(true)
    } else {
      console.error("unrecognized operation: " + buttonType)
    }
  }

  openDialogMenu() {
    console.warn("openDialogMenu(): opening...")
    this.setState({dialogMenuOpen: true})
  }

  openDomainMenu() {
    console.warn("openDomainMenu(): opening...")
    this.setState({domainMenuOpen: true})
  }

  openSubscriptionsMenu() {
    console.warn("openSubscriptionsMenu(): opening...")
    this.setState({subscriptionsMenuOpen: true})
  }

  closeDialogMenu(us) {
    console.warn("closeDialogMenu(): closing...")
    us.setState({dialogMenuOpen: false})
  }

  closeDomainMenu(us) {
    console.warn("closeDomainMenu(): closing...")
    us.setState({domainMenuOpen: false})
  }

  closeSubscriptionsMenu(us) {
    console.warn("closeSubscriptionsMenu(): closing...")
    us.setState({subscriptionsMenuOpen: false})
  }

  handlePostTweetClick() {
    console.warn("handlePostTweetClick():")

    this.setState({openBuilderModal: true})
  }

  async handleViewerClick() {
    console.warn("viewer future function button clicked")

    console.warn("====================================================")
/*
    // Generate an ECDH object for geekA
    const geekA = crypto.createECDH('secp256k1'); //'secp521r1');
    const geekB = crypto.createECDH('secp256k1'); //secp521r1');

    // Create a private key of geekA
    geekA.setPrivateKey("thisisasecretkey!");

    // Create a private key of geekB
    geekB.setPrivateKey("thisisanotherkey!");
  
    // Get the private keys of both the geeks
    let geekAPrivateKey = geekA.getPrivateKey();
    let geekBPrivateKey = geekB.getPrivateKey();
  
    console.log("Private Key of Geek A is:",
            geekAPrivateKey);
    console.log("Private Key of Geek B is:",
            geekBPrivateKey);
*/


    // INSTRUCTIVE: testing call to findLatestContinue2()
    //const res1 = await findLatestContinue2(await openDB(), this.state.domainToVisit, owner);
    //console.error("res1: ", res1)

    // It's possible the search for the logical next address
    // ignored a UTXO that was recently spent without our knowledge
    // FIXME: We could check for an UNSPENT
/* */

    console.warn("====================================================")
  }

  handleDomainBarChange(event) {

    // only allow suitable characters: a-z  0-9, - ?
    const re = /^[a-zA-Z0-9]+$/;

    //NOTE: we ALSO clear the currentTxId, and decodedTx
    //      This will clear any previous site presentation

    if ( event.target.value === '' || re.test(event.target.value)) {
      console.warn("domain bar entry altered: " + event.target.value)

      this.setState({domainToVisit: event.target.value.toLowerCase(),
        reachedLimb: '',
        currentTxId: null,
        decodedTx: '',
        registeredToUs: false,
        weSubscribeToThis: false,
        found: false,
        owned: false
      })
    } else {
      console.warn("ignoring invalid domain: " + event.target.value)
      this.setState({currentTxId: null, decodedTx: '', reachedLimb: ''})
    }
  }

  goToClickedDialog(us, dialogTxId, dialogId) {
    console.warn("goToClickedDialog: " + dialogTxId + " w/ dialogId " + dialogId)

    us.jumpToTx(dialogTxId, us, 'dialog', dialogId)
  }

  goToClickedDomain(us, domain) {
    console.warn("goToClickedDomain: " + domain )

    this.setState({
        domainToVisit: domain,
        reachedLimb: '',
        currentTxId: null,
        decodedTx: '',
        openTheProgressList: true,
        count: this.state.count+1
    })
  }

  goToDomain(event) {
    console.warn("goToDomain: " + this.state.domainToVisit )

    this.setState({openTheProgressList: true, count: this.state.count+1})
    event.preventDefault();
  }

  workCanceled() {
    console.warn("The job was just canceled")
    this.setState({jobCanceled: true})
  }

  reportGuestPostFunc(name) {
    if ( this.state.reportOnGuestPosts && this.props.guestPostReport ) {
      console.error("shizzleView found a guest-poster to report: " + name)
      this.props.guestPostReport(name)
    }
  }

  ///////////////////////////////////

  visitTheGuestFunc(guestLimb) {
    const visitTheGuest = this.state.domainToVisit === guestLimb
    if ( !visitTheGuest ) {
        // maybe reports on the domain of the guest-poster, visiting the domain-to-visit
        this.reportGuestPostFunc( guestLimb )
    }

    return visitTheGuest
  }

  // Find the latest/tip tx for the current domain - but do so from
  // a 'background' thread, keeping the main thread 'active'/alive.
  // This is accomplished using the ProgressListModal to call this.
  // This is the ProgressListModal's registered ourWorkToDo() function
  // It's called-back by the ProgressListModal - to allow seeking on a non-main thread
  // (to keep the UI responsive, and allow canceling)
  // Parameters progressFunc, finishCanceling, doneFunc, and plmReset are pLM functions that WE'LL call-back if/when needed
  //FIXME: rename to seekToTip()
  //FIXME: this is all fairly kludgy. Could call execAsync from within
  //       THIS module, and still present output on the <ProgressListModal>.
  //       NOTE that claimer also employs the PLM.
  async doWork(parent, progressFunc, finishCanceling, doneFunc, target, plmReset) {
    this.plmReset = plmReset
    this.setState({jobCanceled: false})
    console.warn("doWork() on " + target)

    // do work in several steps
    // After each step, send a progress report, and check for cancel

    const checkIfCanceled = () => { return this.state.jobCanceled }

    const finCanceling = (parent) => {
      finishCanceling(parent)
      this.setState({ currentTxId: null,
                      decodedTx: '',
                      found: false,
                      owned: false,
                      reachedLimb: '',
                      extraVerbage: 'canceled'});
    }

    // seek to the tip of the given target domain
    // Along the way, we may call some of these callbacks
    await findTipOfDomain(window.shizzleContext,
                          parent,

                          this.props.blockHeight,   //NEW: to help reduce queries on
                                                    //     Quarterlies, and Periodicals

                          progressFunc,
                          finCanceling,
                          doneFunc,

                          target,

                          this.processSearchResults,

                          this.visitTheGuestFunc,

                          checkIfCanceled,
                          this.props.guestPostWeAreAPartyToCallback)
  } // doWork()
  ///////////////////////////////////


  // Called when a progressListModal-initiated walk of a domain has concluded (reached the tip),
  // or been cancelled.
  // At the end, this.props.subModeResponse() is called (if registered/implemented) to inform
  // the PARENT of the results. It now ALSO reports the results of the furthest quarterly encountered:
  //     resultOfFurthestQuarterly
  async processSearchResults(tipTxId, found, owned, extraWords,
                              resultOfFurthestQuarterly = null,
                              resultOfFurthestPeriodical = null,
                              resultOfFurthestTransient = null) {
    const db = await openDB()
    console.log("shizzleView pSR(): will now process results of search. BTW: resultOfFurthestQuarterly: ", resultOfFurthestQuarterly)
    console.log("shizzleView pSR(): will query tx " + tipTxId + "...")

    // Maybe we don't need to query the provider this time
    // We've probably done it very, very recently
    let limb = ''
    const dtx = await queryFunction(window.shizzleContext, tipTxId, db) // NOTE: Has TEMPORARILY changed false to true on 10/25/23. Also in claimer.
    if ( dtx !== null ) {
      // if it's not in our subscription list, and we haven't yet registered this,
      //     offer a button to register, or follow/subscribe
      // if we have registered it, mention it
      // if it's in our subscription list, mention it

      let registeredToUs = false
      let weSubscribeToThis = false
      if ( found && owned ) {
        console.log("checking if we should offer buttons to subscribe, or register ownership...")

        // is it already owned by us?
        const outputFromWhichToTakeOwnerCount = this.getRelevantOutputIndex( dtx )

        const ownerCount = dtx.outputStates[ outputFromWhichToTakeOwnerCount ].ownerCount
        const limb = hexStringToAscii( dtx.outputStates[ outputFromWhichToTakeOwnerCount ].namePath )
        if ( limb !== this.state.domainToVisit ) {
          throw new Error("11727 - whoops on domain to visit: " + this.state.domainToVisit + " vs " + limb)
        }

        const registrationSearchResult = await findADomainOfMine(db, limb, ownerCount)
        console.warn("results of our domain-registration check: ", registrationSearchResult)

        if ( registrationSearchResult === null ) {
          // We don't have this domain (and latest ownerCount) registered (yet),
          // so, offer to register ownership
          registeredToUs = false
        } else {
          for ( let i = 0; i < registrationSearchResult.length; i++ ) {
            if (registrationSearchResult[i].name === this.state.domainToVisit) {
              registeredToUs = true
              break;
            }
          }
        }


        // do we already subscribe to it?
        const subscriptionSearchResult = await getASubscription(db, limb, ownerCount)
        console.warn("results of our subscription check: ", subscriptionSearchResult)

        if ( subscriptionSearchResult === null ) {
          // We're not subscribed to this domain (and latest ownerCount),
          // and we haven't registered ownership, so, offer to subscribe/follow
          weSubscribeToThis = false
        } else {
          for ( let i = 0; i < subscriptionSearchResult.length; i++ ) {
            if (subscriptionSearchResult[i].name === this.state.domainToVisit) {
              weSubscribeToThis = true
              break;
            }
          }
        }
      }


      // Call maybeDecryptContent() AFTER state.contentPending is true
      this.setState({contentPending: true}, async function() {
            const {dtxString, contentEncrypted} = await maybeDecryptContent( dtx, this.props.getKeyForDecryption )

            this.setState({
                          contentPending: false,
                          contentEncrypted: contentEncrypted,
                          currentTxId: tipTxId,
                          decodedTx: dtxString,
                          found: found,
                          owned: owned,
                          registeredToUs: registeredToUs,
                          weSubscribeToThis: weSubscribeToThis,
                          reachedLimb: limb,
                          extraVerbage: extraWords});

            // Since we're presenting real content, update the address bar
            // But, don't set the address bar if we're in special 'submode' (controlled by surfer, or something)
            if ( found && owned && !this.props.submode ) {
              this.setAddressBar(dtx)
            }

            if ( this.props.subModeResponse ) {
//FIXME: if this is a guestPost, we might not want outputStates[0]. It might depend on the domain of interest
              this.setState({foundOwnerCount: dtx.outputStates[0].ownerCount})
              const furthestQuarterlyTxId = resultOfFurthestQuarterly === null || resultOfFurthestQuarterly.status !== 'success' ?
                          null
                        :
                          resultOfFurthestQuarterly.txId
              const quarterliesWithProfileInfo = resultOfFurthestQuarterly === null || resultOfFurthestQuarterly.status !== 'success' ?
                          []
                        :
                          resultOfFurthestQuarterly.quarterliesWithProfileInfo

              const furthestPeriodicalTxId = resultOfFurthestPeriodical === null || resultOfFurthestPeriodical.status !== 'done' ?
                          null
                        :
                          resultOfFurthestPeriodical.txId
              const periodicalsWithProfileInfo = resultOfFurthestPeriodical === null || resultOfFurthestPeriodical.status !== 'done' ?
                          []
                        :
                          resultOfFurthestPeriodical.periodicalsWithProfileInfo

              const furthestTransientTxId = resultOfFurthestTransient === null || resultOfFurthestTransient.status !== 'success' ?
                          null
                        :
                          resultOfFurthestTransient.txId
              const transientsWithProfileInfo = resultOfFurthestTransient === null || resultOfFurthestTransient.status !== 'success' ?
                          []
                        :
                          resultOfFurthestTransient.transientsWithProfileInfo


              alert("IMPLEMENT ME: (in shizzleView) furthestPeriodicalTxId, periodicalsWithProfileInfo, furthestTransientTxId, transientsWithProfileInfo")
              alert("AND, review: how does decoding a tx affect all this? Did we add code in there (looking for shz_profile info), that makes any of this now useless? or does it empower it?")
              // KEY, perhaps:
              //
              // ah. Perhaps: decoding a tx will result in a .shzl_profile, but HERE, we identify only the RELEVANT (in-path) txs with profile info
              // Thus, as long as the owner maintains his tree in this way (promoting params when possible), user doesn't have to decode EVERY tx in the tree


              console.warn("View: letting caller know we're done... NOTE: furthestQuarterlyTxId: ", furthestQuarterlyTxId)
              console.log("BTW: dtx: ", dtx)
              this.props.subModeResponse(this.parent, found, dtx, tipTxId, furthestQuarterlyTxId, quarterliesWithProfileInfo)
            }
          })

    } else if ( this.props.subModeResponse ) {
      this.setState({foundOwnerCount: 0})
      console.error("shizzleView: Where's the decodexTx string?")
      alert("ERROR?: TBD. In submode, so, letting caller know that the domain search failed")
      this.props.subModeResponse(this.parent, false, null, null, null, [])
    }
  } // processSearchResults

  setAddressBar(tx) {
    let theAddress = tx.outputStates[0].address
    try {
      console.log("setAddressBar(): hostGuestMode: " + tx.outputStates[0].inputParams.hostGuestMode)
      if ( tx.hasGuestPost ) {
        const guestLimb = hexStringToAscii( tx.outputStates[ tx.guestOutIdx ].namePath )
        if ( guestLimb === this.state.domainToVisit ) {
          theAddress = tx.outputStates[ tx.guestOutIdx ].address
          console.warn("setAddressBar(): Switching to GUEST address - for domain " + guestLimb)
        }
      }

      window.history.pushState("", "", "/")
      window.history.pushState("", "", "view/" + theAddress.split('/').slice(2).join('/'))
    } catch (error) {
      console.error("setAddressBar(): error while pushing address " + theAddress + " to browser state? ", error)
      alert("whoops. tried pushing browser state when address is " + theAddress)
    }
  }

  closeProgressList() {
    console.log("closeProgressList() called")
    this.setState({openTheProgressList: false})
  }

  // show a 'toast' for a specified period
  quickToast(toastText, duration=2000, withoutLoader = false) {
      console.warn("quickToast()")
      this.setState({showQuickToast: true, toastText: toastText, toastDuration: duration, suppressLoader: withoutLoader})
      // once expired, quickToastDone() will be called
  }
  // called-back by toast, once it's expired
  quickToastDone(self) {
      self.setState({showQuickToast: false, suppressLoader: false})

      // now that it's expired, do NOTHING
  }
  // current txId passed by child (contentPresenter)
  async shareLinkToPost(txId) {
    console.warn("ShizzleView  shareLinkToPost(): ", txId)
    //console.log("decoded tx: ", this.state.decodedTx)
    const txState = await queryFunction( window.shizzleContext, txId, await openDB(), false );

    // Because our linkJumper doesn't currently handle URLs with guest-posts,
    //   ie an URL like this:
    //     j=someDomain/001/00001/U/00001/T/001/001/003/001/001/001/002/001:00000004host
    // IF this is a guestPost, choose the path of the GUEST (for link-sharing)
    let whichStateToUse = 0
    if ( txState.hasGuestPost ) {
      console.log("This is a guest-post")
      whichStateToUse = txState.guestOutIdx
    }

    const txAddress = txState.outputStates[whichStateToUse].address.split("//")[1]
    console.warn("tx address: ", txAddress)

    const ourOrigin = window.location.href.split("/").slice(0, 3).join('/')
    const linkPath = ourOrigin + "/?j=" + txAddress

    try {
        await navigator.clipboard.writeText( linkPath );
        this.quickToast("Link copied to clipboard", 900, true)
    } catch (error ) {
      // sometimes:
      //   NotAllowedError: The request is not allowed by the user agent or the platform in
      //                    the current context, possibly because the user denied permission.
      // see: https://stackoverflow.com/questions/62327358/javascript-clipboard-api-safari-ios-notallowederror-message
      // tl;dr: "You are trying to copy to the clipboard as a result of an API call
      //         instead of in the context of a user interaction. This is not allowed."
      console.warn("shareLinkToPost(): error: ", error)
      alert("Use this link to share the post:\n\n"
          + linkPath
      )
      return
    }
  }

  // This would be used by ContentPresenter if user clicks on a shizzle link
  // (pointing to a shizzle address)
  //   example:   <bshz bshzType='ajump' bshzArg='bshz://abc/1/2'> click here </bshz>
  // OR, maybe if user selects a dialog from the dialogModal
  // 'mode' can be 'regular', or 'dialog'
  async jumpToTx(txid, parent, txClass='regular', dialogId=0) {
    //NOTE: we couldn't just call saveAndFetch() directly. 'this' was a problem, within saveAndFetch()
    console.log("SSNav::jumpToTx() tx: ", txid)

    // query and decode the tx
    const txState = await queryFunction( window.shizzleContext, txid, await openDB(), true );
    if ( txState === null || typeof txState === 'number' ) {
      //alert("ERROR: failed to retrieve the transaction " + txid + ": " + txState)
      console.error("jumpToTx() failed for txid " + txid + ": " + txState)

      // clean-up (stop the swirling loading thing)
      //this.setState({searchEntry2: '', txToConsider: '', decodedTx: null});
      //this.setState({txToConsider: ''});
      return null
      //FIXME: return something?
    }


    // set state, to jump to alternate location
    //  ( see original example in ShizzleNav's saveAndFetch() )
//FIXME: we should really CALCULATE found, owned, or reached?
    parent.setState({ currentTxId: txid,
                    decodedTx: JSON.stringify( txState ),
                    found: true,
                    owned: true,
                    txClass: txClass,
                    dialogId: dialogId })


    // Set the address bar URL (pathname). The hostname was set once - in ShizzleNav CTOR
    // ( This strips off leading 'bshz://nav', or maybe in the future, 'bshz://view' )
    if ( txState.address ) {
      try {
        window.history.pushState("", "", "/")
        window.history.pushState("", "", "view/" + txState.address.split('/').slice(2).join('/'))
      } catch (error) {
        alert("whoops. tried pushing browser state when address is " + txState.address)
      }

    } else {
      console.warn("Tx has no state (probably legacy). Blanking the address bar path")
      window.history.pushState("", "", "/")
    }
  } // jumpToTx()

  nullProgressFunc(text) {
    console.warn("nullProgressFunc(): " + text)
  }

  /**
   * Jump to the LOGICAL next transaction (for the domainToVisit)
   * If parameter 'reverse' is true, walk BACKWARDS instead.
   *
   * @param {*} reverse
   * @returns
   */
  async handleForward(reverse = false) {
    console.log("FORWARD clicked. BTW: currentTxId is " + this.state.currentTxId)

    console.warn("Reverse? ", reverse)

    const odtx = JSON.parse( this.state.decodedTx );
    let guestPost = false
    let guestLimb = ''

    if ( !odtx ) {
      console.error("handleForward(): no decodedTx to render?")
      alert("ERROR: There's no decoded tx to calc fwd/prev.")
      return
    }

//FIXME: if we're ALREADY at a finalPost, do we need special logic,
//       or can we just search, as normal?

    console.log("hostGuestMode: " + odtx.outputStates[0].inputParams.hostGuestMode)
    let weAreTheGuest = false
    let guestOutIndex
    if ( odtx.hasGuestPost ) {
      guestPost = true
      console.warn("handleForward: Rendering a guest-post")
      const hostLimb = hexStringToAscii( odtx.outputStates[0].namePath );
      guestOutIndex =
            hexStringToAscii( odtx.outputStates[1].namePath ) !== hostLimb ?
                1
              :
                hexStringToAscii( odtx.outputStates[2].namePath ) !== hostLimb ?
                    2
                  :
                    3

      guestLimb = hexStringToAscii( odtx.outputStates[ guestOutIndex ].namePath )

      if ( this.state.domainToVisit === guestLimb ) {
        weAreTheGuest = true
      }

      // IF guest-poster is spawning, Dialog output is #3, else #2 (base-0)
    }

    let address
    let owner
    if ( guestPost && weAreTheGuest ) {
      console.warn("Using the GUEST address")

      address = odtx.outputStates[ guestOutIndex ].address
      owner   = odtx.outputStates[ guestOutIndex ].ownerCount

    } else {
      console.warn("Using the HOST address")
      address = odtx.outputStates[0].address
      owner   = odtx.outputStates[0].ownerCount
    }
    console.warn("handleForward() limbName " + this.state.domainToVisit)
    console.warn("handleForward() current address " + address)
    console.warn("handleForward() current owner " + owner)

    let postNum = 0
    console.warn("handleForward() current txClass: " + this.state.txClass)
    if ( this.state.txClass === 'dialog' ) {
      if (guestPost) {
        postNum = 0
      } else {
        postNum = odtx.outputStates[0].postNum
      }
    }
    const db = await openDB()
    const results = this.state.txClass === 'dialog' ?
                        await getNextDialog(db,
                                            this.state.dialogId,
                                            postNum,
                                            reverse)
                    :
                        await getTheNextAddress(db, this.state.domainToVisit, address, owner, reverse)

    if ( results === null ) {
      console.log("can't go forward (by simply searching an ordered list)")
      console.log("odtx: ", odtx)
      //FIXME: if we're going FORWARD, and this is just before a 'finalPost',
      //       find the finalPost the old-fashioned way - follow the spend
      //       use special logic to look for the first of the next at a higher level
      return
    }

    const nextTxId = results.txid
    console.warn("handleForward(): nextTxId = " + nextTxId)

    //NOTE: Since we're getting this from IDB, we know that it's ALREADY
    //      been decoded, so, there's no need to specify a Guest-Post callback
    let nextTx = await queryFetchDecodeTx(window.shizzleContext, nextTxId, await openDB())
    if ( !nextTx ) {
      alert("hmm. trouble getting nextTx.")
      return; //FIXME: ok?
    }
    console.warn("handleForward(): nextTx = ", nextTx)
    var txString = JSON.stringify( nextTx );
    this.setState({currentTxId: nextTxId,
                    decodedTx: txString})
    if ( !this.props.submode ) {
      this.setAddressBar(nextTx)
    }

    // set contentPending true.
    // THEN decrypt
    // THEN set contentPending false
    this.setState({contentPending: true}, async function() {

            console.warn("shizzleView: handleForward(): will inspect tx (input/content) for prefix flag...")
            const {dtxString, contentEncrypted} = await maybeDecryptContent( nextTx, this.props.getKeyForDecryption )
            this.setState({
                contentPending: false,
                contentEncrypted: contentEncrypted,
                decodedTx: dtxString,
            })
          })

    // give parent a heads-up as to which tx we've navigated
    if ( this.props.postNavNotification ) {
      this.props.postNavNotification(this.props.parent, nextTxId, nextTx)
    }

  } // handleForward()

  async handlePrevious() {
    console.log("Previous clicked. BTW: currentTxId is " + this.state.currentTxId)

    const odtx = JSON.parse( this.state.decodedTx );
    let guestPost = false
    let guestLimb = ''

    if ( !odtx ) {
      console.error("handlePrevious(): no decodedTx to render?")
      alert("ERROR: There's no decoded tx to calc prev.")
      return
    }

    console.log("hostGuestMode: " + odtx.outputStates[0].inputParams.hostGuestMode)
    let weAreTheGuest = false

    // host might also spawn
    const guestIdx = odtx.guestOutIdx
    if ( odtx.hasGuestPost ) {
      guestPost = true
      console.warn("handlePrevious: Rendering a guest-post")
      guestLimb = hexStringToAscii( odtx.outputStates[ guestIdx ].namePath )
      if ( this.state.domainToVisit === guestLimb ) {
        weAreTheGuest = true
      }
    }

    let prevTxId
    let currentMode
    if ( guestPost && weAreTheGuest ) {
      prevTxId = odtx.outputStates[guestIdx].prevTxId
      console.warn("Using the GUEST prevTxId: " + prevTxId)
      currentMode = odtx.outputStates[ guestIdx ].mode
    } else {
      prevTxId = odtx.outputStates[0].prevTxId
      console.warn("Using the HOST prevTxId: " + prevTxId)
      currentMode = odtx.outputStates[0].mode
    }
    const currentAsciiMode = hexByteToAscii(currentMode)
    const currentModeAsInt = Buffer.from(currentMode, "hex").readUInt8(0)
    console.warn("handlePrevious(): currentModeAsInt: " + currentModeAsInt)
    console.warn("handlePrevious(): just BEFORE going back: mode is " + currentAsciiMode)

    if ( prevTxId !== null ) {

      let prevTx = await queryFetchDecodeTx(window.shizzleContext, prevTxId, await openDB())
      let fetchThePrev = false // we're up-to-date so far
      if ( !prevTx ) {
        alert("hmm. trouble.")
        return; //FIXME: ok?
      }
      const prevMode = prevTx.outputStates[0].mode
      const prevAsciiMode = hexByteToAscii( prevMode )
      const prevModeAsInt = Buffer.from(prevMode, "hex").readUInt8(0)
      if ( currentAsciiMode === 'p' ) {
        if (  prevAsciiMode === 'P' || prevAsciiMode === 'K' ) {
          // DONE. too far? maybe should have checked/disabled sooner?
          console.error("DONE going back. too far? check/disable sooner?")
        } else {
          // travel Updates
          console.warn("Travel the Updates now...")

          //const updateRes = await this.tryGoingFurtherInUpdates(window.shizzleContext, prevTxId, this.nullProgressFunc)
          const updateRes = await tryGoingFurtherInUpdates( window.shizzleContext,
                                                            prevTxId,
                                                            this.nullProgressFunc,

                                                            this.props.blockHeight,

                                                            this.visitTheGuestFunc)
          console.warn("   RESULTS of traveling Updates: ", updateRes)
          if ( updateRes.status === 'nope' ) {
            // Continue didn't have an Update
            console.warn(" whoopsie. There was no spawned Update. Use current Continue result. prevTxId is still " + prevTxId)
          } else {
            prevTxId = updateRes.txId
            console.error("WE've GOT A BETTER 'PREV' (an Update)!! (but must fetch it): " + prevTxId)
            fetchThePrev = true
            console.error("  Could NOT find a better trans. Prev is still " + prevTxId)
          }
        }
      } else if ( currentAsciiMode === 'U' ) {
        // P can spawn an update
        if ( prevAsciiMode === 'P' ) {
          // DONE. too far? maybe should have checked sooner?
        } else if ( prevAsciiMode === 'p' ) {
          // Back to Continue. DONE
          console.warn("DONE going back on Updates.")
        } else if ( prevAsciiMode === 'U' ) {
          // travel Transients
          console.error("Travel the Transients now... BUT, not sure if prev mode as int is T4, or T9")
          //const transRes = await this.tryGoingFurtherInTransients(window.shizzleContext, prevTxId, this.nullProgressFunc, 51)
          const transRes = await tryGoingFurtherInTransients( window.shizzleContext,
                                                              prevTxId,
                                                              this.nullProgressFunc,
                                                              this.visitTheGuestFunc,
                                                              51)
          console.warn("   RESULTS of traveling Transients: ", transRes)
          if ( transRes.status === 'success' ) {
            prevTxId = transRes.txId
            console.error("WE've GOT A BETTER 'PREV' (a transient)!! (but must fetch it): " + prevTxId)
            fetchThePrev = true
          } else {
            console.error("  Could NOT find a better trans. Prev is still " + prevTxId)
          }
        }
      } else if ( currentModeAsInt >= 48 && currentModeAsInt <= 57 ) {  // ANY level (except 0???)
        console.warn("We're CURRENTLY Integer mode " + currentModeAsInt + " (T" + currentAsciiMode + ")")
        if ( prevModeAsInt === currentModeAsInt ) {  // if prev matches current
          // travel transients one level lower

          if ( prevModeAsInt !== 48 ) {
            console.warn("Travel the SUB-Transients now...")
            //const subTransRes = await this.tryGoingFurtherInTransients(window.shizzleContext, prevTxId, this.nullProgressFunc, prevModeAsInt - 1)
            const subTransRes = await tryGoingFurtherInTransients(window.shizzleContext,
                                                                  prevTxId,
                                                                  this.nullProgressFunc,
                                                                  this.visitTheGuestFunc,
                                                                  prevModeAsInt - 1)
            console.log("   RESULTS of traveling SUB-Transients: ", subTransRes)
            if ( subTransRes.status === 'success' ) {
              prevTxId = subTransRes.txId
              console.error("WE've GOT A BETTER 'PREV'!! (but must fetch it): " + prevTxId)
              fetchThePrev = true
            } else {
              console.error("  Could NOT find a better sub trans. Prev is still " + prevTxId)
            }
          } else {
            console.warn("We're as low as we can go (can't travel subs). DONE")
          }
        } else {
          // back to Update. DONE
          console.warn("DONE going back on Transients.")
        }
      } else {
        throw new Error("IMPLEMENT ME: we need 'prev' logic for mode " + currentMode)
      }

      if ( fetchThePrev ) {
        prevTx = await queryFetchDecodeTx(window.shizzleContext, prevTxId, await openDB())
        if ( !prevTx ) {
          alert("hmm. trouble now.")
          return; //FIXME: ok?
        }
      }

      var txString = JSON.stringify( prevTx );
      this.setState({currentTxId: prevTxId,
                      decodedTx: txString})

      if ( !this.props.submode ) {
        this.setAddressBar(prevTx)
      }

    } else {
      alert("Hmm. trouble getting prev.")
    }
  } // handlePrevious()

  async unRegisterADomainOfMine(event) {
    event.preventDefault();
    console.warn("unRegisterADomainOfMine(): Will UN-register " + this.state.domainToVisit)

    const db = await openDB();
    const domainRec = await unRegisterDomainOfMine(db, this.state.domainToVisit)
    console.warn("Here's the record we created: ", domainRec)

    this.setState({registeredToUs: false})
  }

  async registerADomainOfMine(event) {
    event.preventDefault();

    const ownerCount = this.getOwnerCountAndLimb().ownerCount

    console.warn("registerADomainOfMine(): Will register " + this.state.domainToVisit)


    const db = await openDB();
    const domainRec = await registerDomainOfMine(db, this.state.domainToVisit, ownerCount)
    console.warn("Here's the record we created: ", domainRec)

    this.setState({registeredToUs: true})
  }

  // which output has the relevant OWNER COUNT
  getRelevantOutputIndex (odtx) {

    console.log("getRelevantOutputIndex(): [0].contract: " + odtx.outputStates[0].contract)
    console.log("getRelevantOutputIndex(): hStA(0.namePath) = " + hexStringToAscii( odtx.outputStates[0].namePath ))
    console.log("getRelevantOutputIndex(): this.state.domainToVisit = " + this.state.domainToVisit)

    const relevantOutputIndex =
        odtx.outputStates[0].contract !== 'transient' ?
            0
          :
            hexStringToAscii( odtx.outputStates[0].namePath ) === this.state.domainToVisit ?
                0
              :
                hexStringToAscii( odtx.outputStates[1].namePath ) === this.state.domainToVisit ?
                    1
                  :
                    2
    console.warn("getRelevantOutputIndex(): relevantOutputIndex = " + relevantOutputIndex)

    return relevantOutputIndex
  }

  getOwnerCountAndLimb() {
    // Results and state variables were set in processSearchResult()

    if ( this.state.decodedTx === '' ) {
      console.warn("getOwnerCountAndLimb(): trouble. No decodedTx.")
      return
    }

    const odtx = JSON.parse( this.state.decodedTx );
    if ( !odtx ) {
      console.warn("getOwnerCountAndLimb(): trouble")
      //alert?
      return
    }

    let ownerCount
    let limb
    if ( odtx.outputStates[0].contract === 'dialog' ) {
      console.warn("Dialog, so, namePath prob irrelevant")
      ownerCount = odtx.outputStates[0].ownerOwnerCount
      limb = odtx.outputStates[0].ownerName
      if ( limb !== this.state.domainToVisit && odtx.outputStates[0].visitorName !== this.state.domainToVisit ) {
        throw new Error("11728+1 - whoops on domain to visit: " + this.state.domainToVisit + " vs " + limb)
      }
    } else {
      const outputFromWhichToTakeOwnerCount = this.getRelevantOutputIndex(odtx)
      ownerCount = odtx.outputStates[ outputFromWhichToTakeOwnerCount ].ownerCount
      limb = hexStringToAscii( odtx.outputStates[ outputFromWhichToTakeOwnerCount ].namePath )

      if ( limb !== this.state.domainToVisit ) {
        throw new Error("11728 - whoops on domain to visit: " + this.state.domainToVisit + " vs " + limb)
      }
    }

    return {
              ownerCount: ownerCount,
              limb:       limb
           }
  }

  async subscribeToDomain(event) {
    event.preventDefault();

    const ownerCount = this.getOwnerCountAndLimb().ownerCount

    console.warn("subscribeToDomain(): Will subscribe to " + this.state.domainToVisit + " - owner " + ownerCount)

    const db = await openDB();
    await registerASubscription(db, this.state.domainToVisit, ownerCount)
    console.warn("Registered.")

    this.setState({weSubscribeToThis: true})
  }

  async unSubscribeToDomain(event) {
    event.preventDefault();

    console.warn("unSubscribeToDomain(): Will UNsubscribe to " + this.state.domainToVisit)

    const db = await openDB();
    await unRegisterASubscription(db, this.state.domainToVisit)
    console.warn("UN-registered.")

    this.setState({weSubscribeToThis: false})
  }

  render() {
	  console.warn("ShizzleView render()  Current asset: " + this.state.domainToVisit)

    const goButtonDisabled = this.state.domainToVisit.length < 1
    const theCurrentTxId = this.state.currentTxId
    const found = this.state.found
    const owned = this.state.owned

    //console.warn("decodedTx: ", this.state.decodedTx)

    let txPresentation = null
    let ownerCount = 0
    let limb = ''
    if ( this.state.decodedTx === '' || theCurrentTxId === null ) {
      txPresentation = null
    } else {
      const odtx = JSON.parse( this.state.decodedTx );
      const guestIdx = odtx.guestOutIdx
      let guestPost = false
      //FIXME: what's a good init value? check index.js
      let guestLimb = ''
      if ( !odtx ) {
        console.error("ShizzleView(): no decodedTx to render?")
        alert("ERROR: There's no decoded tx.")
        return
      } else {
        console.log("shizzleView(): [0].inputParams: ", odtx.outputStates[0].inputParams)
      }

      console.log("hostGuestMode: " + odtx.outputStates[0].inputParams.hostGuestMode)
      // a transient's input0Param will only ever contain 0, 1 (or, perhaps undefined?)
      if ( odtx.hasGuestPost ) {
        guestPost = true
        console.warn("ShizzleView: Rendering a guest-post")
        guestLimb = hexStringToAscii( odtx.outputStates[ guestIdx ].namePath )
      }

      if ( !found ) {
        txPresentation = <></>
      } else if ( !owned ) {
        txPresentation = <>
                                  <strong style={{color: 'blue'}}>
                                    '{odtx.limbName}'
                                  </strong>&nbsp;
                                    was found, but it's not yet been claimed. &nbsp; {theCurrentTxId}
                                </>
      } else {

        // found, and owned

        console.log("ShizzleView render(): object decodedTx: ", odtx)

        /* <ContentPresenter contentPresenterTx={this.state.txToConsider}
                          decodedTx={this.state.decodedTx}
                          jumpToLinkedAsset={this.jumpToTx}
                          guestPost={guestPost}/>
        */

        let addressofInterest
        if ( guestPost ) {
          // looking for this.state.domainToVisit
          console.warn("guest limb: " + guestLimb)
          console.warn("visiting: " + this.state.domainToVisit)
          if ( guestLimb === this.state.domainToVisit ) {
            addressofInterest = odtx.outputStates[ guestIdx ].address
          } else {
            addressofInterest = odtx.outputStates[0].address
          }
        } else {
          console.warn("NOT a guest post")
          addressofInterest = odtx.address
        }

        let disablePrev = false
        let startOfDomainMention = null
        const addressParts = addressofInterest.split('/')
        if ( addressParts.length === 5 ) {
          console.warn("This is a quarterly.")
          if ( addressParts[3] === '001' &&
              addressParts[4] === '00001' ) {
                console.log("This is the START of the domain. Disable Prev.")
                disablePrev = true
                startOfDomainMention = <>
                                        This is where the domain began. It's history starts here.<br></br>
                                       </>
              }
        }

        const disableFwd = false
        let previousButton = <span style={{verticalAlign: '10%'}}><Button disabled={disablePrev} onClick={() => this.handleForward(true)}><Icon name="arrow left"></Icon>Prev Tx</Button></span>
        let forwardButton = <span style={{verticalAlign: '10%'}}><Button disabled={disableFwd} onClick={() => this.handleForward(false)}>Next Tx<Icon name="arrow right"></Icon></Button></span>

        /* It appears that swapping between two ContentPresenters (based on state.contentPending) was overkill
           It's the <iframe> within the ContentPresenter that was the real culprit of presenting stale (encrypted) content
        const staticContentPresenter =
                                      <>
                                        <ContentPresenter contentPresenterTx={theCurrentTxId}
                                                          domainOfInterest={this.state.domainToVisit}
                                                          parent={this}
                                                          decodedTx={`{"input0Params":{"content":"48"},"outputStates":["h"]}`}
                                                          guestPost={false}
                                                          jumpToLinkedAsset={ this.jumpToTx }
                                                          submode={this.props.submode}
                                                  contentPending={true}
                                                          contentEncrypted={false}
                                                          />
                                      </>
        */

        const presenter =
                              <>
                                <ContentPresenter contentPresenterTx={theCurrentTxId}
                                                  domainOfInterest={this.state.domainToVisit}
                                                  parent={this}
                                                  decodedTx={this.state.decodedTx}
                                                  guestPost={guestPost}
                                                  jumpToLinkedAsset={ this.jumpToTx }
                                                  shareLinkToContent={ this.shareLinkToPost }
                                                  submode={this.props.submode}
                                          contentPending={this.state.contentPending}
                                                  contentEncrypted={this.state.contentEncrypted}
                                                  />
                              </>


        const rndString = 'identicon ' + this.state.domainToVisit.toLowerCase() + ':' + this.state.foundOwnerCount

        const siteIdenticon = <span style={{margin:'0px 0px 0px 0px', padding: '0px 0px 0px 0px', verticalAlign:'-60%'}}>
                                <Identicon string={rndString} size='40'/>
                              </span>;

        const navigationAndIdenticon =
              <>

                      {previousButton} &nbsp;&nbsp;

                      {siteIdenticon} &nbsp; &nbsp;

                      {forwardButton}

              </>
        //FIXME: at some point will need jumpToLinkedAsset, and guestPost (for real)
        //       Neither should be difficult
        txPresentation =
              <>
                <div style={{fontSize:'0.72rem'}}>
                  {addressofInterest}
                </div>
                <div style={{fontSize:'0.63rem'}}>
                  {theCurrentTxId}
                </div>
                <br></br>
                {navigationAndIdenticon}

                {startOfDomainMention}

                {presenter}
              </>
        const aCaL = this.getOwnerCountAndLimb()
        ownerCount = aCaL.ownerCount
        limb       = aCaL.limb
      }
    } // we have some results to present

    const title = <>Heading to the latest post for <b>{this.state.domainToVisit.toUpperCase()}</b></>
    //FIXME: when switching back to ShizzleNav, clear

    const dialogMenuView = this.state.dialogMenuOpen ?
                            <>
                              <DialogModal parent={this}
                                           domain={limb}
                                           ownerCount={ownerCount}
                                           dialogClickHandler={this.goToClickedDialog}
                                           closeModal={this.closeDialogMenu}/>
                            </>
                        :
                            <>
                            </>
    const domainMenuView = this.state.domainMenuOpen ?
                            <>
                              <DomainModal parent={this}
                                           domainClickHandler={this.goToClickedDomain}
                                           closeModal={this.closeDomainMenu}/>
                            </>
                        :
                            <>
                            </>
    const subscriptionsMenuView = this.state.subscriptionsMenuOpen ?
                            <>
                              <SubscriptionsModal parent={this}
                                                  domainClickHandler={this.goToClickedDomain}
                                                  closeModal={this.closeSubscriptionsMenu}/>
                            </>
                        :
                            <>
                            </>
    const subscriptionButton = !this.state.weSubscribeToThis ?
                              !this.state.registeredToUs && found && owned ?
                                    <>
                                      <br></br>
                                      If you like this asset ('{this.state.domainToVisit}'), you may wish to &nbsp;
                                      <Button positive content="Subscribe to it" onClick={this.subscribeToDomain} />
                                    </>
                                  :
                                    <>
                                    </>
                          :
                              <>
                                <br></br>
                                You are currently subscribed to this domain.<br></br>
                                If you grow tired of this domain, you can &nbsp;
                                <Button positive content="UN-subscribe to it" onClick={this.unSubscribeToDomain} />
                              </>
    const registrationButton = !this.state.registeredToUs ?
                              (!this.state.weSubscribeToThis && this.state.owned && this.state.found ?
                                      <>
                                        <br></br>
                                        If you actually own/control this asset ('{this.state.domainToVisit}'), you should &nbsp;
                                        <Button positive content="Register ownership" onClick={this.registerADomainOfMine} />
                                      </>
                                    :
                                      <>
                                      </>
                              )
                          :
                              <>
                                <br></br>
                                You've registered this domain - as something you own/control. <br></br>
                                If you no-longer own/control it, you should &nbsp;
                                <Button positive content="UN-Register ownership" onClick={this.unRegisterADomainOfMine} />
                              </>
    const currentDomain = this.state.domainToVisit === '' ?
                                  'none selected'
                                :
                                  this.state.domainToVisit
    const displayOfCurrentDomain = this.state.found && this.state.owned ?
                                  <>
                                    <span style={{color: 'blue'}}>
                                        {currentDomain}
                                    </span>
                                  </>
                                :
                                  <>
                                    <span style={{color: 'red'}}>
                                        {currentDomain}
                                    </span>
                                  </>
    const disableDialogs = this.state.domainToVisit === '' || !this.state.found || !this.state.owned
    const currentDomainIsOurs = this.state.registeredToUs
    const mentionIfOurs = currentDomainIsOurs ? ' (your domain)' : null
    const mentionIfSubscribed = this.state.weSubscribeToThis ? ' (we subscribe to this)' : null
    const dialogViewButtonWording = currentDomainIsOurs ?
                                        <>
                                          View your dialogs FROM this domain of yours
                                        </>
                                      :
                                        <>
                                          View your dialogs WITH this domain - from ANY of yours
                                        </>

    const maybeTypicalUpperDisplay = this.props.submode ?
            <>
            </>
          :
            <>

              This is the ShizzleViewer <br></br>
              It's the best way to view and follow BitShizzle domains. <br></br>


              <button onClick={this.handleViewerClick}>Some future function</button>
              <p></p>
              <button onClick={this.handlePostTweetClick}>Post/Tweet something</button>
              <p></p>
              <button onClick={this.openSubscriptionsMenu}>View/Select your subscriptions</button>
              <br></br>
              <button onClick={this.openDomainMenu}>View/Select your domains</button>
              <p></p>Current domain: {displayOfCurrentDomain} {mentionIfOurs}{mentionIfSubscribed}
              <br></br>
              &nbsp; &nbsp; <button disabled={disableDialogs} onClick={this.openDialogMenu}> {dialogViewButtonWording} </button>
              <p></p>
              <button onClick={this.props.handleSwitchToShizzleNav}>Switch to ShizzleNav</button>
              <Divider />

              <form>
                <label name='searchLabel'>
                  BitShizzle domain to visit: &nbsp;
                  <Input placeholder='Enter a domain name'
                            value={this.state.domainToVisit}
                            style={{width: "200px"}}
                            className="limb-input-field"
                            onChange={this.handleDomainBarChange} />
                  &nbsp; &nbsp;
                  <Button type="submit" content="GO/Fetch" disabled={goButtonDisabled} onClick={this.goToDomain} />
                </label>
              </form>

              {subscriptionButton}
              {registrationButton}
            </>

    const maybeTypicalLowerDisplay = this.props.submode ?
            <>
            </>
          :
            <>
              {dialogMenuView}
              {domainMenuView}
              {subscriptionsMenuView}
            </>

    const maybeQuickToast = this.state.showQuickToast ?
            <>
            <Toast  durationMillis={this.state.toastDuration}
                displayText={this.state.toastText}
                noLoader={this.state.suppressLoader}
                done={this.quickToastDone}
                parent={this}/>
            </>
        :
            <></>
    return (
      !this.props.show ?
          null
        :
          <>
            <div style={{padding: "5px"}}>
              {maybeTypicalUpperDisplay}

              {txPresentation}

              {maybeTypicalLowerDisplay}
            </div>

            <ProgressListModal openProgressList={this.state.openTheProgressList}
                          fleeting={this.props.submode}
                          domain={this.state.domainToVisit}
                          ourWorkToDo={this.doWork}
                          onCancel={this.workCanceled}
                          onDone={this.closeProgressList}
                          title={title}
                          description="Since we currently operate in a proof-of-concept 'Serverless' mode, this will require a few steps..."/>
            {maybeQuickToast}
          </>
    ) // return ()
  } // render()
} // shizzleView

// ========================================

export default ShizzleView;
